import React,{useState} from "react";
import Banner from "../../images/bannerf.jpeg";
import Imageone from "../../images/images.jpeg";

function NewBanner(params) {
  
    
  return(
      <img src={Banner} alt="" width="100%"/>
  )
}

export default NewBanner;
